import React from "react";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";

import { Col, Form, Icon, Input, Button, Checkbox, message } from "antd";
import { dispatchUser, toSignUp } from "../Actions/user.actions";
import { Parse } from "parse";
//import { logIn } from '../Actions/user.actions';

const FormItem = Form.Item;

class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false
    };

    //  this.handleSubmit = this.handleSubmit.bind(this);
    //  this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    //var user = this.props.user;
  }

  /*  componentDidUpdate(){
    user = this.props.user;
  }
*/

  handleSubmit = e => {
    var ctx = this;
    e.preventDefault();
    //var username;
    //var password;
    // this.props.form.validateFiels est une fonction antd qui récupère les valeurs des différents champs
    this.props.form.validateFields((error, values) => {
      if (error) {
        message.error("Vérifie bien que tous les champs sont remplis !");
      } else {
        var username = values.username;
        var password = values.password;
        Parse.User.logIn(username, password, {
          success: async function(user) {
            // The current user is now set to user.
            //test de condition : l'utilisateur a-t-il fini de remplir son profil ?
            if (!user.attributes.professional || user.attributes.professional === false) {
              if (
                user.attributes.firstName !== undefined &&
                user.attributes.nickName &&
                user.attributes.gender !== undefined &&
                user.attributes.adresse !== undefined &&
                user.attributes.birthDate !== undefined
              ) {
                // si le user a un nom, un gender, alors il peut accéder au reste du site
                message.success(
                  `Nous sommes heureux de vous revoir ${
                    user.attributes.firstName
                  } ${user.attributes.lastName} !`
                );
                await user.save();
                ctx.props.finishLogIn(user);
              } else {
                // dans ce cas, l'utilisateur doit finir de remplir son profil et sera redirigé vers la page sign-up.
                message.success(
                  `Bienvenue ! Finissez votre profil pour accéder au reste du site`
                );
                ctx.props.redirectToSignUp(user);
              }
            } else if (user.attributes.professional === true) {
              if (
                user.attributes.firstName !== undefined &&
                user.attributes.nickName &&
                user.attributes.gender !== undefined &&
                user.attributes.adresse !== undefined &&
                user.attributes.birthDate !== undefined &&
                user.attributes.programme !== undefined &&
                user.attributes.job !== undefined &&
                user.attributes.qualification !== undefined &&
                user.attributes.cardNumber !== undefined &&
                user.attributes.additionalDescription !== undefined
              ) {
                // si le user a un nom, un gender, alors il peut accéder au reste du site
                message.success(
                  `Nous sommes heureux de vous revoir ${
                    user.attributes.firstName
                  } ${user.attributes.lastName} !`
                );
                ctx.props.finishLogIn(user);
                await user.save();
              } else {
                // dans ce cas, l'utilisateur doit finir de remplir son profil et sera redirigé vers la page sign-up.
                message.success(
                  `Bienvenue ! Finissez votre profil pour accéder au reste du site`
                );
                ctx.props.redirectToSignUp(user);
              }
            }
          },
          error: function(user, error) {
            // The login failed. Check error to see why.
            if (error.code === 101) {
              // The token could not be validated.
              message.error(
                "Ton mot de passe ou ton adresse email est incorrecte"
              );
            } else if (error.code === 100) {
              // The token could not be validated.
              message.error(
                "Impossible de se connecter aux serveurs de Urban Fitness"
              );
            } else {
              message.error("Erreur: " + error.code + " " + error.message);
            }
          }
        });
      }
    });
  };

  render() {
    var redirectToSignUp = this.props.user.redirectToSignUp;
    var redirect = this.props.user.redirect;

    if (redirectToSignUp === true) {
      return <Redirect to="/signup" />;
    } else if (redirect === true) {
      return <Redirect to="/profile" />;
    }

    const { getFieldDecorator } = this.props.form;

    return (
      <Col lg={{ offset: 4 }} md={{ offset: 4 }} sm={{ offset: 8 }}>
        <h3>Se connecter</h3>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <FormItem onChange={this.handleChange}>
            {getFieldDecorator("username", {
              rules: [
                {
                  required: true,
                  message: "Veuillez indiquer votre adresse mail"
                }
              ]
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Adresse mail"
              />
            )}
          </FormItem>
          <FormItem onChange={this.props.handleChange2}>
            {getFieldDecorator("password", {
              rules: [
                {
                  required: true,
                  message: "Veuillez inscrire votre mot de passe"
                }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Mot de passe"
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator("remember", {
              valuePropName: "checked",
              initialValue: true
            })(<Checkbox>Se souvenir de moi</Checkbox>)}
            <Link className="login-form-forgot" to="/forgotpassword">
              Mot de passe oublié
            </Link>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Se connecter
            </Button>
          </FormItem>
        </Form>
      </Col>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    finishLogIn: user => {
      dispatch(dispatchUser(user));
    },
    redirectToSignUp: user => {
      dispatch(toSignUp(user));
    }
  };
};

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);
